import { Sidebar } from "primereact/sidebar";
import "./new-patient-visit.scss";
import { useNavigate, useSearchParams } from "react-router-dom";
import NewVisit from "@domain/visit/new-visit/new-visit";
import TextBlock from "@shared/ui/text-block/text-block";
import { Divider } from "primereact/divider";

/* eslint-disable-next-line */
export interface NewPatientVisitProps {}

export function NewPatientVisit() {
  const navigate = useNavigate();
  let [searchParams] = useSearchParams();

  const defaultPatientName = searchParams.get("name");
  return (
    <div id="NewPatientVisit" className="new-patient-visit">
      <Sidebar
        visible={true}
        onHide={() => navigate("../")}
        className="w-full md:w-[500px]"
      >
        {defaultPatientName ? (
          <section>
            <h3>{defaultPatientName}</h3>
            <Divider className="mb-12" />
          </section>
        ) : null}
        <NewVisit isAlone={true} />
      </Sidebar>
    </div>
  );
}

export default NewPatientVisit;
